import React from 'react';

const Aux =(props)=>{
    return(
        <div>
            {props.children}
        </div>
    )
};

export default Aux;


// WEBPACK FOOTER //
// ./src/hoc/Auth/Auth.js